import { useEffect, useMemo, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { a11yProps } from 'pages/globals/global';
import LynIcon from 'components/@extended/LynIcon';
import plusIcon from 'assets/images/icons/plus.svg';
import comptroller from 'assets/images/comptroller_white.svg';
import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { decodeQueryParamData } from 'utils/utils';
import { useParams } from 'react-router-dom';

const LeasePageHeader = ({
	image,
	title,
	navigate,
	selectedTab,
	selectTabHandler,
	tabsItem,
	activeCreateButton,
	reloadCountApi,
	createBtn = true,
}) => {
	const theme = useTheme();
	const [tabCounts, setTabCounts] = useState([]);

	const params = useParams();
	const state = useMemo(() => decodeQueryParamData(params?.id), []);

	const [sendControlData] = useSendControlDataMutation();

	useEffect(() => {
		const fetch = async () => {
			if (state?.processCode) {
				const res = await sendControlData({
					// data: convertBase64,
					processCode: state?.processCode,
					scriptName: 'leaseConsoleTabItemsCount',
				});

				if (res?.data?.status === 'SUCCESS') {
					const tabData = res?.data?.responseData ?? {};

					setTabCounts(tabData);
				}
			}
		};

		fetch();
	}, [state?.processCode, reloadCountApi]);

	return (
		<Box
			sx={{
				width: '100%',
				borderRadius: 1,
				'& .MuiStack-root': { height: '60px !important' },
			}}
		>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				style={{ borderRadius: '6px 6px 0 0' }}
				sx={{
					px: '15px',
					py: '12px',
					color: 'common.white',
					bgcolor: '#214689',
				}}
			>
				<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
					<img alt="comptroller" src={image ? image : comptroller} width="20px" height="18px" />

					<Typography variant="h4">{title}</Typography>
				</Stack>

				{createBtn && (
					<Button
						type="primary"
						disabled={activeCreateButton}
						onClick={navigate}
						sx={{
							backgroundColor: activeCreateButton ? 'gray' : theme.palette.lynTheme.success,
							boxShadow: 'none',
							border: `1px solid ${activeCreateButton ? 'gray' : theme.palette.lynTheme.success}`,
							borderColor: '#ffff',
							padding: '3px 15px',
							display: 'flex',
							alignItems: 'center',
							color: 'white',
							transition: 'all 0.1s',
							fontSize: '13px',
							fontWeight: '500',
							borderRadius: '6px',

							'&:hover': {
								backgroundColor: activeCreateButton ? 'gray' : '#207f3b',

								transform: 'scale(1.05)',
							},
						}}
					>
						<img src={plusIcon} alt="add" width="12" height="12" style={{ marginRight: '8px' }} />
						Create
					</Button>
				)}
			</Stack>

			{tabsItem && (
				<Box sx={{ width: '100%', backgroundColor: 'white' }} style={{ borderRadius: '0px 0px 6px 6px' }}>
					<Tabs
						value={selectedTab}
						textColor="inherit"
						allowScrollButtonsMobile
						onChange={selectTabHandler}
						aria-label="basic tabs example"
						variant="scrollable"
						scrollButtons="auto"
						sx={{
							'& .MuiTabs-indicator': {
								backgroundColor: '#214689',
								borderRadius: '0px 0px 0px 6px',
							},

							'& .Mui-selected': {
								color: '#214689',
							},

							'& .MuiTab-root': {
								backgroundColor: 'white',
								opacity: 1,
							},
						}}
					>
						{tabsItem?.map((item, index) => (
							<Tab
								key={item.label}
								label={`${item.label} ${tabCounts?.[item?.key] > 0 ? ' (' + tabCounts?.[item?.key] + ') ' : ''}`}
								iconPosition="start"
								icon={<LynIcon folder="icons" fileName={item.icon} format="svg" sx={{ marginRight: '16px' }} />}
								sx={{
									padding: '5px 50px',
								}}
								{...a11yProps(index)}
							/>
						))}
					</Tabs>
				</Box>
			)}
		</Box>
	);
};

export default LeasePageHeader;
